/**
 * Created by noOne on 21/09/2017.
 */
"use strict";
import Common from "./Common";
import GlitchFilter from "./GlitchFilter";

export default class ResultsScene extends P3.Scene {
    constructor() {
        super();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._uiLayer = new PIXI.Container();

        /**
         * @type {Button}
         * @private
         */
        this._soundBtn = null;
    }

    init() {

        let bg = P3.createSprite("game_over_bg", this._primaryHolder);
        bg.anchor.set(0.5, 0);
        bg.x = Common.STAGE_WIDTH * 0.5;

        //--set vis so we can animate in without seeing a frame of it visible--//
        // this._uiLayer.visible = false;

        //--add holders--//
        this.addChild(this._primaryHolder, this._uiLayer);

        //--add bg--//
        //  const bg = P3.createSprite("game_bg", this._primaryHolder);
        // bg.anchor.set(0);

        // Common.renderer.backgroundColor = 0xc1f1ff;
        const panel = P3.createSprite("panel", this._uiLayer);
        panel.anchor.set(0.5, 0);
        panel.x = Common.STAGE_WIDTH * 0.5;
        panel.y = -100;

        // const gameOverTxtView = P3.simpleText("GAME OVER", "consolas", 80, panel, 0x00ff40);
        const gameOverTxtView = createText(Common.copy.gameover[Common.language], {
            size: 80,
            fill: 0x76718a
        }, "Ed Gothic");
        gameOverTxtView.x = -46;
        gameOverTxtView.y = 135;
        gameOverTxtView.anchor.set(0.5, 0);
        panel.addChild(gameOverTxtView);

        const scoreWordTxtView = createText(Common.copy.score[Common.language], {
            size: 80,
            fill: 0x01ff46,
            stroke: 0x30b45e
        }, "Ed Gothic");
        scoreWordTxtView.x = -46;
        scoreWordTxtView.y = 230;
        scoreWordTxtView.anchor.set(0.5, 0);
        panel.addChild(scoreWordTxtView);

        //  const rect = P3.createSprite("rectangle_bg", panel);
        /// rect.x = -70;
        //  rect.y = panel.height * 0.5 - 150;

        // const scoreTxtView = P3.simpleText("" + Common.results.score + " " + Common.copy.pts[Common.language], "consolas", 80, rect, 0xffffff);
        const scoreTxtView = createText("" + Common.results.score /* + " " + Common.copy.pts[Common.language]*/, {
            size: 125,
            fill: 0xffffff,
            stroke: 0x469f6e
        }, "Digital-7");
        scoreTxtView.x = -46;
        scoreTxtView.y = 345;
        scoreTxtView.anchor.set(0.5, 0);
        panel.addChild(scoreTxtView);

        //  const bestTxtView = P3.simpleText(Common.copy.bestscore[Common.language], "consolas", 50, panel, 0x00ff40)
        const bestTxtView = createText(Common.copy.bestscore[Common.language], {
            size: 55,
            fill: 0x01ff46,
            stroke: 0x30b45e
        }, "Ed Gothic");
        bestTxtView.x = -65 + 20;
        bestTxtView.y = 455;
        bestTxtView.anchor.set(0.5, 0);
        panel.addChild(bestTxtView);

        //  const bScoreTxtView = P3.simpleText("" + Common.highestScore + " " + Common.copy.pts[Common.language], "consolas", 50, panel, 0xffffff);
        const bScoreTxtView = createText("" + Common.highestScore + " " + Common.copy.pts[Common.language], {
            size: 75,
            fill: 0xffffff,
            stroke: 0x1da14d
        }, "Digital-7");
        bScoreTxtView.x = -55 + 20;
        bScoreTxtView.y = 515;
        bScoreTxtView.anchor.set(0.5, 0);
        panel.addChild(bScoreTxtView);

        /*
         const homeBtn = Common.createButton(-130, P3.View.height - 170, "med", ()=> {
         this.signals.home.dispatch(this);
         }, this, panel, null, "icon_home");
         */
        const homeBtn = P3.simpleButton("med", "home", ()=> {
            this.signals.home.dispatch(this);
        }, this);
        homeBtn.x = -130;
        homeBtn.y = P3.View.height - 70;

        const playBtn = P3.simpleButton("big", "replay", this.end.bind(this), this);
        playBtn.x = 22;
        playBtn.y = P3.View.height - 70;

        this._soundBtn = P3.simpleMute();
        this._soundBtn.y = 100;

        this._uiLayer.addChild(this._soundBtn);
        panel.addChild(homeBtn, playBtn);
        /*

         const playBtn = Common.createButton(22, P3.View.height - 170, "big", ()=> {
         this.end();
         }, this, panel, null, "icon_replay");
         */
        /*
         let str = "icon_sound_on";
         if (Common.isMute) str = "icon_sound_off";
         const soundBtn = Common.createButton(P3.View.width * 0.5 - 100, 100, "small", ()=> {
         console.log("mute click");
         Common.isMute = !Common.isMute;
         Common.audio.mute(Common.isMute);
         Common.saveMute();
         if (!Common.isMute) soundBtn.icon.texture = Common.assets.texture("icon_sound_on");
         else soundBtn.icon.texture = Common.assets.texture("icon_sound_off");
         }, this, this._uiLayer, null, str);
         this._soundBtn = soundBtn;
         */


        //--set glitch filter active world filters--//
        // this._worldHolder.filters = [this._glitchFilter];
        // this._worldHolder.filters = [pixelFilter];
        this._glitchFilter = new GlitchFilter(10);
        this._glitchFilter.uAmp = 0.001;
        this._glitchFilter.uFreq = 0.002;

        //--lazily used a recursive function to make the glitch effect--//

        /*
         var glitcher = ()=> {

         panel.filters = [this._glitchFilter];

         delay(()=> {

         panel.filters = null;

         delay(()=> {
         glitcher();
         }, 2.5, this);

         }, 0.15, this);

         };

         glitcher();*/
        Common.audio.stopMusic();
        Common.audio.playMusic("music_results_loop_00");

        this.initCharacters();
    }

    initCharacters() {

        const king = P3.createSprite("iceking_endgame", this._uiLayer);
        king.anchor.set(0.5, 1);
        king.x = Common.STAGE_WIDTH * 0.5 - 475;
        king.y = P3.View.height - 10;

        this.breathTween(king, 0.1);

        const gunter = P3.createSprite("penguin_endgame", this._uiLayer);
        gunter.anchor.set(0.5, 1);
        gunter.x = Common.STAGE_WIDTH * 0.5 - 545;
        gunter.y = P3.View.height;

        this.breathTween(gunter, 0.2);

        const princess = P3.createSprite("princess_endgame", this._uiLayer);
        princess.anchor.set(0.5, 1);
        princess.x = Common.STAGE_WIDTH * 0.5 + 385;
        princess.y = P3.View.height;

        this.breathTween(princess, 0.3);

        const marc = P3.createSprite("marceline_endgame", this._uiLayer);
        marc.anchor.set(0.5, 1);
        marc.x = Common.STAGE_WIDTH * 0.5 + 245;
        marc.y = P3.View.height;

        this.breathTween(marc, 0.4);
    }

    breathTween(sprite, t = 0) {
        t += Math.random();
        TweenMax.to(sprite.scale, 1.25, {
            x: 0.99,
            y: 1.007,
            yoyo: true,
            repeat: -1,
            ease: Power1.easeIn,
            yoyoEase: Power1.easeIn,
            delay: t
        });
    }

    /**
     animateIn() {
        TweenMax.from(this._uiLayer, 0.75, {
            y: -P3.View.height,
            ease: Bounce.easeOut
        });
        delay(()=> {
            this._uiLayer.visible = true;
        }, 0.1, this);
    **/

    start() {
        this._running = true;
    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);
        Common.audio.stopMusic();
    }

    update() {

    }

    destroy() {
        TweenMax.killAll();

        super.destroy();

        Common.audio.stopMusic();
    }

    resize() {
        //  this._uiLayer.x = P3.View.width * 0.5;
        //  this._soundBtn.x = P3.View.width * 0.5 - 100;
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
        this._soundBtn.x = (Common.STAGE_WIDTH + P3.View.width) * 0.5 - 100;
    }
}